import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import * as reducers from '../reducers';


const  combineAppReducers = combineReducers(reducers);

const appReducers = ( state, action ) => {
  if ( action.type === 'CLEAR_STATE' ) {
    state = undefined;
  }
  return combineAppReducers(state, action)
}


export default function configureStore(initialState) {
	const store = createStore(appReducers, initialState, compose(
		applyMiddleware(thunk),
		window.devToolsExtension ? window.devToolsExtension() : f => f
	));

	if (module.hot) {
		// Enable Webpack hot module replacement for reducers
		module.hot.accept('../reducers', () => {
			const nextReducer = require('../reducers');
			store.replaceReducer(nextReducer);
		});
	}

	return store;
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js